function trimDeep(item: any): any {
  if (exists(item)) {
    if (item instanceof String || typeof item === "string") {
      return item.trim()
    } else if (item instanceof Array) {
      item.forEach(subitem => trimDeep(subitem))
    } else if (!(item instanceof Date)
      && !(item instanceof Number)
      && !(item instanceof Function)
      && typeof item !== "number"
      && typeof item !== "function") {
      Object.keys(item).forEach((key: any) => {
        if (item[key] instanceof String || typeof item[key] === "string") {
          item[key] = trimDeep(item[key])
        } else {
          trimDeep(item[key])
        }
      })
    }
  }
  return item
}

(window as any).trimDeep = trimDeep
